import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-play-icon",
  "use": "icon-play-icon-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-play-icon\"><path d=\"M0 512a512 512 0 1 0 1024 0A512 512 0 1 0 0 512z\" fill=\"#E6E6E6\" /><path d=\"M694.212 471.341l-248.47-161.13c-39.154-22.587-69.271-4.517-69.271 40.66v322.258c0 43.671 31.623 61.742 69.27 40.66l246.965-161.13c39.153-22.588 39.153-58.73 1.506-81.318z\" fill=\"#DC0000\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/play-icon.svg
// module id = EDQM
// module chunks = 65